import {MappedFromData} from './MappedFromData';

export class MappedDataItem {
  table: string;
  name: string;
  id: string;
  mappedFromData: MappedFromData;
  displayClass = 'unmapped';

  constructor(table: string, name: string, id: string, mappedFromData: MappedFromData = new MappedFromData ('', '', 0), displayClass: string = 'unmapped') {
    this.table = table;
    this.name = name;
    this.id = id;
    this.mappedFromData = mappedFromData;
    this.displayClass = displayClass;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/data/MappedDataItem.ts